
import { useEffect, useState } from 'react';
import Papa from 'papaparse';
import { GalleryItem } from '../types/gallery';

const METADATA_URL = '/data/paintings/metadata.csv';

export function deriveCategory(item: GalleryItem): string {
    const cat = (item['Category'] || '').toString().trim();
    if (cat) return cat;
    const src = (item.ID || item.File || '').toString();
    const base = src.split('/').pop() || src;
    const nameNoExt = base.replace(/\.[a-zA-Z0-9]+$/, '');
    const prefix = nameNoExt.split('_')[0].toLowerCase();
    switch (prefix) {
        case 'landscape': return 'landscape';
        case 'stilllife':
        case 'stillife': return 'still life';
        case 'market': return 'markets & crowds';
        case 'portrait': return 'portrait';
        case 'people': return 'people';
        case 'plants': return 'plants';
        default: return 'other';
    }
}

export function formatGalleryMetadata(item: GalleryItem): string {
    return `${item['Name'] || ''} ${item['Year'] ? `(${item['Year']})` : ''}, ` +
        `${item['Medium'] || ''}${item['Material'] ? ` on ${item['Material']}` : ''}, ` +
        `${item['Width (cm)'] || ''}${item['Width (cm)'] ? ' cm' : ''}${item['Height (cm)'] ? ' x ' : ''}${item['Height (cm)'] || ''}${item['Height (cm)'] ? ' cm' : ''}`;
}

export function useGalleryData(onDataLoaded?: (items: GalleryItem[], categories: string[]) => void) {
    const [items, setItems] = useState<GalleryItem[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);
    const [categories, setCategories] = useState<string[]>([]);

    useEffect(() => {
        fetch(METADATA_URL)
            .then((response) => {
                if (!response.ok) throw new Error('Failed to load metadata');
                return response.text();
            })
            .then((csvText) => {
                const parsed = Papa.parse(csvText, { header: true });
                const rows: GalleryItem[] = (parsed.data as any[]).filter(r => r && (r.ID || r.File));
                setItems(rows);
                // report categories up for filter bar
                const catSet = new Set<string>();
                rows.forEach(r => { const c = deriveCategory(r); if (c) catSet.add(c); });
                const cats = Array.from(catSet).sort((a, b) => a.localeCompare(b));
                setCategories(cats);
                if (onDataLoaded) {
                    onDataLoaded(rows, cats);
                }
                setLoading(false);
            })
            .catch((err) => {
                setError(err.message);
                setLoading(false);
            });
    }, [onDataLoaded]);

    return { items, loading, error, categories };
}
